import { render, staticRenderFns } from "./VAInfoBox.vue?vue&type=template&id=681603aa&"
import script from "./VAInfoBox.vue?vue&type=script&lang=js&"
export * from "./VAInfoBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports